import { Id, Identifiable, Milestone } from "@planzone/dto";
import { LinkedResource } from "../linkers/types";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { linkResources } from "../utils/linkResources";
import { mapError } from "../utils/mapError";

function editMilestone(httpClient: HttpClient) {
  return (milestone: Identifiable<Milestone>, nextMilestone: Milestone) =>
    httpClient
      .sendHttpRequest<
        LinkedResource<Identifiable<Milestone>> & {
          modifiedElements?: {
            tasks?: { uuid: Id; endDate: string; startDate: string }[];
            activities?: {
              uuid: Id;
              endDate: string;
              startDate: string;
              minStartDate?: string;
              maxStartDate?: string;
              minEndDate?: string;
              maxEndDate?: string;
            }[];
            milestones?: { uuid: Id; endDate: string; startDate: string }[];
          };
        }
      >({
        endpoint: `/milestones/${milestone.uuid}`,
        method: HttpMethods.PATCH,
        data: {
          name: nextMilestone.name,
          description: nextMilestone.description,
          endDate: nextMilestone.endDate,
          keyRank: nextMilestone.keyRank,
          state: nextMilestone.state,
          completedAt: nextMilestone.completedAt,
          ...(!!nextMilestone.attributes && {
            attributes: nextMilestone.attributes,
          }),
        },
      })
      .then((milestone) => linkResources(httpClient, milestone))
      .then((milestone) => ({
        ...milestone,
        tags: milestone.tags
          ? milestone.tags.map((tag) => {
              // @ts-ignore
              return typeof tag === "string" ? { name: tag } : tag;
            })
          : [],
        impactedElements: (!!milestone.modifiedElements
          ? [
              ...(milestone.modifiedElements.tasks || []).map((t) => ({
                ...t,
                type: "task",
              })),
              ...(milestone.modifiedElements.activities || []).map((t) => ({
                ...t,
                type: "list",
              })),
              ...(milestone.modifiedElements.milestones || []).map((t) => ({
                ...t,
                type: "milestone",
              })),
            ]
          : []) as {
          type: "task" | "list" | "milestone";
          uuid: Id;
          endDate: string;
          startDate: string;
          minStartDate?: string;
          maxStartDate?: string;
          minEndDate?: string;
          maxEndDate?: string;
        }[],
      }))
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            emptyName: "emptyName",
            duplicateName: "duplicateName",
            endDateOutOfBound: "endDateOutOfBound",
            notFound: "notFound",
            listNotFound: "listNotFound",
          }),
        ),
      );
}

export { editMilestone };
